import {Component, Output, EventEmitter, Input} from '@angular/core';

/*##################################################################################* 
 * COMPOSANT SPRO : spro-dialog-button
 * 
 * DESCRIPTION : Bouton des fenêtre de dialogue
 * 
 ##################################################################################*/

@Component({
  selector: 'spro-dialog-button',  
  styleUrls: ['./spro-dialog-button.component.scss'],
  template: `
  <kendo-dialog-actions>
    <button type="button"
            class="k-button k-primary"
            [disabled]="!f_actif"
            (click)="proc_onSave($event)">
      <span class="k-icon k-i-check"></span>
    </button>
    
    <button type="button"
            class="k-button"
            (click)="proc_onCancel($event)">
      <span class="k-icon k-i-cancel"></span>
    </button>
  </kendo-dialog-actions>
  `,
})
export class spro_cls_dialog_button {

  /** Pour désactiver le bouton Save */
  @Input() f_actif: boolean = true;
  
  /** Déclaration événement sur click */
  @Output() e_save: EventEmitter<any> = new EventEmitter();
  /** Déclaration événement sur click */
  @Output() e_cancel: EventEmitter<any> = new EventEmitter();

  /**
   * Evénements sur click
   */
  public proc_onSave(e): void {
    e.preventDefault();
    this.e_save.emit();
  }
  
  /**
   * Evénements sur click
   */
  public proc_onCancel(e): void {
    e.preventDefault();
    this.e_cancel.emit();
  }
}


// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/buttons/spro-dialog-button/spro-dialog-button.component.ts